var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return [_c('a',{attrs:{"href":"https://www.shiwei.love/","target":"_blank"}},[_vm._v("广东省侍卫健康科技产业有限公司 版权所有 © 2021-2024 shiwei.love All Rights Reserved")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }